module.exports = __webpack_public_path__ + "img/Doom.cba4ab4e.png";